<template>
  <component :is="element" :disabled="Loading" class="hover:cursor-pointer" @click="openModal">
    <tw-loading-spinner-mini v-if="Loading">
      Preparing...
    </tw-loading-spinner-mini>
    <span v-else>Send Support Request</span>
  </component>
</template>

<script>
import html2canvas from 'html2canvas'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'
import { useSupportRequestsStore } from '@/stores/supportRequests.js'

export default {
  name: 'SendSupportRequestButton',
  components: { TwLoadingSpinnerMini, TwLoadingSpinner },
  props: {
    element: {
      type: String,
      default: 'tw-button'
    }
  },
  emits: ['open-modal'],
  data () {
    return {
      Loading: false
    }
  },
  methods: {
    async openModal (bvEvent) {
      if (bvEvent) {
        bvEvent.preventDefault()
      }
      this.Loading = true
      const canvas = await html2canvas(document.querySelector('body'))
      useSupportRequestsStore().supportRequestScreenshotBlobSet(canvas)
      this.$emit('open-modal', canvas)
      this.Loading = false
    }
  }
}
</script>

<style scoped>

</style>
